import { useField } from "formik";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import React from "react";
import AsyncSelect from "react-select/async";
import { rootUrl } from "stores/redux/actions/constants";

const loadOptions = async (inputValue, owner) => {
  console.log(inputValue, owner);
  if (inputValue.length < 3) {
    return [];
  }
  const obj = {};
  if (!isNaN(inputValue) && inputValue.trim() !== "") {
    obj["ctepId"] = Number(inputValue);
  } else {
    obj["personName"] = inputValue;
  }
  try {
    return await makeAjaxRequest.postWithAuth(
      `${rootUrl}/admin/managecommittee/participants/${owner}/ctepidlov`,
      {
        ...obj
      }
    );
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export default function PersonAutocomplete(props) {
  const [field, , helpers] = useField(props.name ? props.name : props.field);
  const { setValue, setTouched, setError } = helpers;
  const values = props?.form?.values || {};


  const setFieldProps = (selectedOption) => {
    setValue(selectedOption?.value);
    if (props.onChange && typeof props.onChange === "function") {
      props.onChange(selectedOption);
    }
    setTimeout(() => {
      setTouched(true);
      setError(undefined);
    }, 0);
  };

  return (
    <AsyncSelect
      value={{
        perId: values?.perId || "",
        ctepId: values?.personCtepId || "",
        personName: values?.personName || ""
      }}
      cacheOptions
      onChange={setFieldProps}
      loadOptions={(searchText) => loadOptions(searchText, props.owner)}
      noOptionsMessage={() => "Type at least 3 characters to search"}
      loadingMessage={() => "Searching..."}
      menuPortalTarget={document.body}
      data-id={`select-${props.name}`}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      className={`reactSelect-wrapper ${!props.edit ? "reactSelect-readOnly" : "mt-1"}`}
      classNamePrefix="reactSelect"
      getOptionValue={(option) => field.name === "personCtepId" ? option.ctepId : option.personName}
      getOptionLabel={(option) => field.name === "personCtepId" ? option.ctepId : option.personName}
    />
  );
}
